// extracted by mini-css-extract-plugin
export default {"metadata":"styles-module__metadata__src-labstep-web-core-DataGrid-Text-WithMetadata-_VfyvT"};